import React from "react";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
}

export default function GhostButton({ children, className = "", ...rest }: Props) {
  return (
    <button
      type="button"
      className={`inline-flex items-center gap-1.5 text-[var(--color-primary)] text-sm font-medium hover:underline transition-all disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}
